import React from 'react'
import { useGLTF } from '@react-three/drei'

import OmbrelloneGenerale from './OmbrelloneGenerale'

export function OmbrelloneBraccioPratiqueContract() { 
  const { nodes } = useGLTF(`${process.env.PUBLIC_URL}/models/ombrelloneB/ombrelloneBraccioPratique.gltf`);

  return (
    <OmbrelloneGenerale 
                      nodeCorpoName={nodes.Mesh_21.geometry} 
                      nodeTeloName={nodes.Mesh_427.geometry}                 
                      rot1={[-Math.PI / 2, 0, 0]}  
                      sc1={0.025}                
                      rot2={[-Math.PI / 2, 0, 0]}   
                      sc2={0.025}                    
                      mainRotation={[Math.PI/2, -Math.PI, 0]}
    />
  )
}

export function OmbrelloneBraccioPratiqueContractMantovana() { 
  const { nodes } = useGLTF(`${process.env.PUBLIC_URL}/models/ombrelloneB/ombrelloneBraccioPratiqueMantovana.gltf`);

  return (
    <OmbrelloneGenerale 
                      nodeCorpoName={nodes.Mesh_0.geometry} 
                      nodeTeloName={nodes.Telo.geometry}                 
                      rot1={[-Math.PI / 2, 0, 0]}  
                      sc1={0.025}                
                      rot2={[-Math.PI / 2, 0, 0]}   
                      sc2={0.025}                    
                      mainRotation={[0, -Math.PI, 0]}
    />
  )
}

useGLTF.preload(`${process.env.PUBLIC_URL}/models/ombrelloneB/ombrelloneBraccioPratique.gltf`)
useGLTF.preload(`${process.env.PUBLIC_URL}/models/ombrelloneB/ombrelloneBraccioPratiqueMantovana.gltf`)

